/**
 *
 * UploadFileButton
 *
 */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import UploadMedia from 'containers/UploadMedia';

function UploadFileButton({ name, onAdd, className }) {
  const { t, i18n } = useTranslation();
  const mainClassNames = classNames('tcf-fb-upload-file', className);

  const renderButton = useMemo(
    () => !!onAdd && (
      <UploadMedia className={mainClassNames} uploadChange={onAdd}>
        <CustomIcons className="tcf-fb-upload-file__icon" type="arrow-right" />
        <span className="tcf-fb-upload-file__label">
          {t('inputs.addDocument')}
        </span>
      </UploadMedia>
    ),
    [onAdd, i18n?.language],
  );

  return renderButton;
}

UploadFileButton.defaultProps = {
  name: 'media',
  mediaFiles: [],
};
UploadFileButton.propTypes = {
  onAdd: PropTypes.func,
};

export default UploadFileButton;
